const galleryImages = [
    { id: 1, img: "/assets/pic1.JPG", title: "Temple View" },
    { id: 2, img: "/assets/pic2.JPG", title: "Sacred Lamp" },
    { id: 3, img: "/assets/pic3.JPG", title: "Evening Pooja" },
    { id: 4, img: "/assets/pic4.JPG", title: "Temple Entrance" },
    { id: 5, img: "/assets/pic5.JPG", title: "Festival Lights" },
    { id: 6, img: "/assets/pic6.JPG", title: "Deepam" },
    { id: 7, img: "/assets/pic7.JPG", title: "Devotees" },
    { id: 8, img: "/assets/pic8.JPG", title: "Sanctum View" },
    { id: 9, img: "/assets/2.jpg", title: "Sacred Ritual" },
    { id: 10, img: "/assets/2.jpg", title: "Temple Decor" },
    { id: 11, img: "/assets/2.jpg", title: "Flower Offering" },
    { id: 12, img: "/assets/2.jpg", title: "Holy Atmosphere" },
];

const gallery = [
    { id: 1, img: "/assets/1.jpeg", title: "Temple View" },
    { id: 2, img: "/assets/im9.jpeg", title: "Sacred Lamp" },
    { id: 3, img: "/assets/im5.jpeg", title: "Evening Pooja" },
    { id: 4, img: "/assets/im4.jpeg", title: "Temple Entrance" },
    { id: 5, img: "/assets/im3.jpeg", title: "Festival Lights" },
    // { id: 6, img: "/assets/im10.jpeg", title: "Deepam" },
    { id: 7, img: "/assets/im7.jpeg", title: "Devotees" },
    { id: 8, img: "/assets/im6.jpeg", title: "Sanctum View" },
    { id: 9, img: "/assets/img2.jpeg", title: "Sacred Ritual" },
    { id: 10, img: "/assets/im12.jpeg", title: "Temple Decor" },
    { id: 11, img: "/assets/im13.jpeg", title: "Flower Offering" },
    { id: 12, img: "/assets/im14.jpeg", title: "Holy Atmosphere" },
];

export default galleryImages;
export { gallery };